/**
 * Shows the waitlist only for the selected unavailable variant and keeps the
 * Shopify customer-form tag specific to that variant.
 */
function updateWaitlists(detail) {
  const { container, productId, variant } = detail || {};
  if (!container || !productId) return;

  const isUnavailable = !variant || variant.available === false;
  container.querySelectorAll('[data-product-waitlist]').forEach((waitlist) => {
    if (waitlist.dataset.productId !== String(productId)) return;

    const forceShow = waitlist.dataset.forceShow === 'true';
    waitlist.hidden = !forceShow && !isUnavailable;
    const trigger = waitlist.querySelector('[data-waitlist-open]');
    const fields = waitlist.querySelector('[data-waitlist-fields]');
    if (!forceShow && !isUnavailable && trigger && fields) {
      trigger.hidden = false;
      trigger.setAttribute('aria-expanded', 'false');
      fields.hidden = true;
    }

    const tags = waitlist.querySelector('[data-waitlist-tags]');
    if (tags && variant?.id) {
      const handle = waitlist.dataset.productHandle || 'product';
      tags.value = `waitlist,waitlist-product-${handle},waitlist-variant-${variant.id}`;
    }
  });
}

document.addEventListener('product-waitlist:variant-change', (event) => updateWaitlists(event.detail));

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-waitlist-open]');
  if (!trigger) return;

  const waitlist = trigger.closest('[data-product-waitlist]');
  const fields = waitlist?.querySelector('[data-waitlist-fields]');
  if (!fields) return;

  fields.hidden = false;
  waitlist.classList.add('is-open');
  trigger.remove();
  fields.querySelector('input[type="email"]')?.focus();
});
